import { classNames } from './classNames';

export type ButtonVariant = 'pill' | 'outline' | 'text';
export type ButtonSize = 'sm' | 'md' | 'lg';
/** `positive` auf hellen Flächen, `negative` auf Schwarzwald und anderen dunklen Flächen. */
export type ButtonContrast = 'positive' | 'negative';

export interface ButtonLookProps {
  variant?: ButtonVariant | undefined;
  size?: ButtonSize | undefined;
  contrast?: ButtonContrast | undefined;
  /** Zeigt bei Hover und Druck das Plant-Icon. */
  hoverIcon?: boolean | undefined;
  /** Für Handlungen, die sich nicht rückgängig machen lassen (Absagen, Entfernen): Fehlerfarbe, immer mit Wort. */
  danger?: boolean | undefined;
}

/** Die Klassen einer Schaltfläche — für Elemente, die keine `<button>` sind (`<a>`, `Link`, Menüeinträge). */
export function buttonClassName(
  { variant = 'pill', size = 'md', contrast = 'positive', danger = false }: ButtonLookProps = {},
  className?: string,
): string {
  return classNames(
    'ksb-btn',
    `ksb-btn--${variant}`,
    `ksb-btn--${size}`,
    contrast === 'negative' && 'ksb-btn--neg',
    danger && 'ksb-btn--danger',
    className,
  );
}
